export interface QuizOption {
  label: string
  score: number
}

export interface QuizQuestion {
  id: string
  category: string
  question: string
  description?: string
  options: QuizOption[]
}

export const questions: QuizQuestion[] = [
  {
    id: 'q1',
    category: 'Data Maturity',
    question: 'How well organized and integrated is your internal data?',
    description: 'On unified data management and accessibility',
    options: [
      { label: 'Data is scattered across departments and not integrated', score: 1 },
      { label: 'Some data is integrated, but silos remain', score: 2 },
      { label: 'Key data is integrated with a shared foundation', score: 3 },
      { label: 'Fully integrated and operated via a data lake / DWH', score: 4 },
    ],
  },
  {
    id: 'q2',
    category: 'Data Quality',
    question: 'How well are data quality and freshness managed?',
    options: [
      { label: 'Hardly managed, with reliability issues', score: 1 },
      { label: 'Partially checked, but standards are unclear', score: 2 },
      { label: 'Regular cleansing and quality checks are in place', score: 3 },
      { label: 'Automated quality monitoring with real-time alerts', score: 4 },
    ],
  },
  {
    id: 'q3',
    category: 'Business Processes',
    question: 'How digitized are your business processes?',
    options: [
      { label: 'Mostly paper or Excel-based, with heavy manual work', score: 1 },
      { label: 'Basic systems are in place but disconnected', score: 2 },
      { label: 'Core operations are automated and connected via SaaS', score: 3 },
      { label: 'End-to-end automated and optimized', score: 4 },
    ],
  },
  {
    id: 'q4',
    category: 'People & Organization',
    question: 'Do you have in-house talent driving AI / data initiatives?',
    options: [
      { label: 'No specialists; fully reliant on external partners', score: 1 },
      { label: 'A few staff handle it as a side responsibility', score: 2 },
      { label: 'A dedicated team or department is in place', score: 3 },
      { label: 'A CDO / CAIO leads cross-functional efforts', score: 4 },
    ],
  },
  {
    id: 'q5',
    category: 'Executive Commitment',
    question: 'How committed is leadership to leveraging AI?',
    options: [
      { label: 'No concrete discussions yet', score: 1 },
      { label: 'Interest exists, but investment decisions are on hold', score: 2 },
      { label: 'AI is included in the mid-term plan', score: 3 },
      { label: 'AI sits at the core of corporate strategy', score: 4 },
    ],
  },
  {
    id: 'q6',
    category: 'Infrastructure',
    question: 'What is the state of your cloud / AI infrastructure?',
    options: [
      { label: 'Mostly on-premise, with limited cloud usage', score: 1 },
      { label: 'Some systems migrated to the cloud', score: 2 },
      { label: 'Core systems run in the cloud', score: 3 },
      { label: 'Cloud-native, with AI/ML platforms in place', score: 4 },
    ],
  },
  {
    id: 'q7',
    category: 'Use Cases',
    question: 'Are the specific challenges you want AI to solve well defined?',
    options: [
      { label: 'Unclear on what AI can do; problems are vague', score: 1 },
      { label: 'A few ideas exist, but priorities are undecided', score: 2 },
      { label: 'Priority challenges identified; PoCs under consideration', score: 3 },
      { label: 'Multiple use cases already running in production', score: 4 },
    ],
  },
  {
    id: 'q8',
    category: 'Governance',
    question: 'How mature is your AI / data governance and ethics framework?',
    options: [
      { label: 'No formal policies or standards', score: 1 },
      { label: 'Only basic rules such as personal data protection', score: 2 },
      { label: 'AI usage guidelines have been formalized', score: 3 },
      { label: 'Ethics committee and audit framework in place', score: 4 },
    ],
  },
]

export const totalQuestions = questions.length
export const maxScore = questions.length * 4
